module.exports = __webpack_public_path__ + "img/avtar.79fffdec.png";